import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { UserProfilePage } from '@/features/membership/profile'

export const Route = createFileRoute('/_authenticated/membership/profile')({
  validateSearch: z.object({
    applicationId: z.coerce.number().int().positive().optional(),
  }),
  component: MembershipProfileRoute,
})

function MembershipProfileRoute() {
  const { applicationId } = Route.useSearch()

  return <UserProfilePage applicationId={applicationId} />
}
